import { homApi } from '~/redux/apis/hom'
import { Student, Preference } from '~/types/tutoring-api'
import { IUser } from '~/types/user-info-types'
import { transformPreference } from '~/utils'
import { STUDENT_API_TAGS } from '~/redux/constants/tags.const'

export const studentApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getStudentExists: builder.query<boolean | undefined, void>({
      query: () => '/v1/student-exists',
    }),

    getProfile: builder.query<Student | undefined, void>({
      query: () => '/v1/students',
      transformResponse(response: Student<'from-api-response'>) {
        if (!response) return

        return {
          ...response,
          preference: transformPreference(response.preference),
        }
      },
    }),

    getStudent: builder.query<Student | undefined, { studentId: number }>({
      providesTags: [STUDENT_API_TAGS.StudentPreference],
      query: (params) => `/v1/students/${params.studentId}`,
      transformResponse(response: Student<'from-api-response'>) {
        if (!response) return

        return {
          ...response,
          preference: transformPreference(response.preference),
        }
      },
    }),

    editStudent: builder.mutation<
      void,
      {
        studentId: number
        preference: Partial<Preference>
        user: Partial<IUser>
      }
    >({
      invalidatesTags: [STUDENT_API_TAGS.StudentPreference],
      query: (data) => ({
        url: `/v1/students/${data.studentId}`,
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
})

export const { useGetStudentExistsQuery, useGetProfileQuery, useGetStudentQuery, useEditStudentMutation } = studentApi
